document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
  let form = event.target; // The form that triggers the change

  /* CUSTOM made to order feature */
  const policy = document.querySelector('.js-variant[data-id="'+variant.id+'"]').getAttribute('data-policy');
  const qty = document.querySelector('.js-variant[data-id="'+variant.id+'"]').getAttribute('data-quantity');
  const price = document.querySelector('.js-variant[data-id="'+variant.id+'"]').getAttribute('data-price');
  const avail = document.querySelector('.js-variant[data-id="'+variant.id+'"]').getAttribute('data-available');

  if(policy == 'continue' && qty <= 0) {
    document.querySelector('.atc_note_avail').style.display = 'none';
    document.querySelector('.atc_note').style.display = 'block';
  } else {
    document.querySelector('.atc_note').style.display = 'none';
    if (avail == 'true') {
      document.querySelector('.atc_note_avail').style.display = 'block';
    } else {
      document.querySelector('.atc_note_avail').style.display = 'none';
    }  
  }
  /* CUSTOM made to order feature */
  
});